var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.79 11.82L3.323 8.355c-.208-.208-.208-.546 0-.754l.754-.754c.208-.209.546-.209.754 0L7.167 9.18l5.002-5.002c.208-.208.546-.208.754 0l.754.754c.208.209.208.546 0 .755L7.544 11.82c-.209.208-.546.208-.754 0z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckmark;